import { render } from "./Cell.vue?vue&type=template&id=3b5573ef&scoped=true"
import script from "./Cell.vue?vue&type=script&lang=ts"
export * from "./Cell.vue?vue&type=script&lang=ts"

import "./Cell.vue?vue&type=style&index=0&id=3b5573ef&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b5573ef"

export default script